module.exports = __webpack_public_path__ + "img/corp-qd_2x.9204711b.jpg";